// extracted by mini-css-extract-plugin
export default {"subTitle":"FormSubTitle_subTitle__wK3s4","fontWeight600":"FormSubTitle_fontWeight600__AuaRU","fontWeight500":"FormSubTitle_fontWeight500__TNXJg"};